document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('[data-skin-quiz-results]').forEach(function (root) {

    var emailTrigger = root.querySelector('[data-skin-quiz-email-trigger]');
    var emailModal = document.querySelector('[data-skin-quiz-email-modal]');
    if (emailTrigger) {

      emailTrigger.addEventListener('click', function () {
        console.log(window.skin_survey);
        var apiEndpoint = root.getAttribute('data-skin-quiz-api-endpoint') || '';
        var apiKey = root.getAttribute('data-skin-quiz-api-key') || '';
        fetch('https://' + apiEndpoint + '/api/skin-survey-update', {
          method: 'POST',
          headers: {
            'x-api-key': apiKey,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(window.skin_survey)
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Failed to update skin survey: ' + response.status + ' ' + response.statusText);
            } else {
                console.log('Skin survey updated successfully:', response);
                emailTrigger.closest(".skin-quiz-results__email-button").querySelector(".email-send-notification").classList.remove("hidden");
                 emailTrigger.classList.add("hidden");

                 setTimeout(()=>{
                     emailTrigger.closest(".skin-quiz-results__email-button").querySelector(".email-send-notification").classList.add("hidden");
                    emailTrigger.classList.remove("hidden");
                 }, 2000)
            }
         
          })
          .catch(function (error) {
            console.error(error);
          });
      });
    }

    var addToBagButton = root.querySelector('[data-skin-quiz-add-to-bag]');

    if (addToBagButton) {
      addToBagButton.addEventListener('click', function () {

        if (addToBagButton.classList.contains('working')) return;

        var items = [];

        root.querySelectorAll('[data-skin-quiz-variant-id]').forEach(function (elm) {
          var id = elm.getAttribute('data-skin-quiz-variant-id');
          if (id) {
            items.push({ id: id, quantity: 1 });
          }
        });

        if (items.length === 0 || typeof window.handleAddToCart !== 'function') return;

        addToBagButton.classList.add('working');

        window.handleAddToCart(
          JSON.stringify({ items: items }),
          items.length,
          { 'Content-Type': 'application/json' },
          function () {
            addToBagButton.classList.remove('working');
          }
        );

      });
    }

  });

});
